module.exports = __webpack_public_path__ + "images/feature/doc-tag-2-e32e8776def434ad9fa8e28954634170.png";